<template>
  <div>
    <BasePopup v-model="isPopupOpen" customClass="custom-popup mn-wd480">
      <div class="popup-header">
        <h3 class="title">비회원 견적서 출력</h3>
        <button type="button" class="btn-cancel" @click="handleClose()"></button>
      </div>
      <div class="popup-body">
        <p class="popup-text">견적서 출력을 위해 필요한 정보를 입력해주세요.</p>
        <div class="form-box mt28">
          <div class="form-group">
            <HconInput type="text" v-model="guestInfo.companyName" ref="inputCompayNmInpTextRef" label="기업명" inputClass="md" placeholder="기업명을 입력해주세요." :required="true"/>
          </div>
          <div class="form-group mt20">
            <HconInput type="text" v-model="guestInfo.managerName" ref="inputManagerNmInpTextRef" label="담당자명" inputClass="md" placeholder="담당자명을 입력해주세요." :required="true"/>
          </div>
        </div>
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box col2">
          <button type="button" @click="handleClose()" class="btn btn-outline md">취소</button>
          <button type="button" @click="onConfirmInfo()" class="btn md">확인</button>
        </div>
      </div>
    </BasePopup>
  </div>
</template>
<script lang="ts" setup>
import BasePopup from '@/components/com/HconComBasePopup.vue'
import HconInput from '@/components/com/HconComPCInputField.vue'

import { ESTIMATE_CODE } from "@/constants/hconMessageConstants"
import { ref } from 'vue'

//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

const { showAlert } = usePopup() // 팝업
const isPopupOpen = ref(false)
const inputCompayNmInpTextRef = ref<InstanceType<typeof HconInput> | null>(null)
const inputManagerNmInpTextRef = ref<InstanceType<typeof HconInput> | null>(null)
const guestInfo = ref({ 
    companyName: ''
  , managerName: ''
})

const emit = defineEmits(['onSubmitGuestInfo', 'close'])

// 팝업 닫힘
const handleClose = () => {
  isPopupOpen.value = false
  emit('close')
}

// 팝업 열림
const handleOpen = () => {
  isPopupOpen.value = true;
}

const onConfirmInfo = () => {

  // 기업명 체크
  if(guestInfo.value.companyName.length === 0 || String(guestInfo.value.companyName).trim() === '') {
    showAlert({
      title: '알림',
      message: ESTIMATE_CODE.ALT_HCON_9188,
      confirmText: '확인',
      onConfirm: () => {
        if(inputCompayNmInpTextRef.value) {
          inputCompayNmInpTextRef.value.onInputTextFocus();
        }
      }
    })
    return
  }

  // 담당자명 체크
  if(guestInfo.value.managerName.length === 0 || String(guestInfo.value.managerName).trim() === '') {
    showAlert({
      title: '알림',
      message: ESTIMATE_CODE.ALT_HCON_9189,
      confirmText: '확인',
      onConfirm: () => {
        if(inputManagerNmInpTextRef.value) {
          inputManagerNmInpTextRef.value.onInputTextFocus();
        }
      }
    })
    return
  }

  emit('onSubmitGuestInfo', { ...guestInfo.value })
}

defineExpose({ handleOpen, handleClose });

</script>
<style lang="scss">

</style>